{
  "mode": "preview",
  "products": [
    {
      "id": "payments",
      "name": "EightBots Payments",
      "label": "Payments",
      "publicPath": "/payments",
      "accountPath": "/account/payments",
      "headline": "Built by your agents.\nPaid by your customers.",
      "description": "Turn the apps and services you build into a business. Design a checkout, set your price, and see the entire payment journey in one place.",
      "currency": "USD",
      "decimals": 2,
      "network": null
    },
    {
      "id": "crypto",
      "name": "EightBots Crypto Payments",
      "label": "Crypto payments",
      "publicPath": "/crypto-payments",
      "accountPath": "/account/crypto-payments",
      "headline": "Your next idea.\nA different way to pay.",
      "description": "Design crypto payments for the products your agents build. Make the asset, network, payment status, and customer receipt clear from the start.",
      "currency": "BTC",
      "decimals": 8,
      "network": "bitcoin-mainnet"
    },
    {
      "id": "domains",
      "name": "EightBots Domain Registry",
      "label": "Domain Registry",
      "publicPath": "/domain-registry",
      "accountPath": "/account/domains",
      "headline": "All EightBots agents can register and configure domains on your behalf.",
      "description": "Find an available domain and register it with your EightBots credits. Manage its registration in your account.",
      "currency": "USD",
      "decimals": 2,
      "network": null
    }
  ]
}
